import { parseISO, format } from 'date-fns';

export function htmlToStructuredText(html) {
    if (!html) return '';
    
    const div = document.createElement('div');
    div.innerHTML = html;

    const lines = [];
    const walk = (node) => {
    
    if (node.nodeType === Node.TEXT_NODE) {
        const t = node.nodeValue.replace(/\s+/g, ' ').trim();
        if (t) lines.push(t);
        return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const tag = node.tagName.toLowerCase();

    // Block starts: push a newline before headings/paragraphs/list items
    if (['h1','h2','h3','h4','h5','h6','p','li'].includes(tag)) lines.push('\n');

    if (tag === 'li') lines.push('• '); // bullet marker

    // Recurse
    for (const child of node.childNodes) walk(child);

    // Block ends: add a newline after blocks
    if (['h1','h2','h3','h4','h5','h6','p','li','br'].includes(tag)) lines.push('\n');
    };

    for (const child of div.childNodes) walk(child);

    // Collapse extra newlines/spaces
    return lines.join('')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/[ \t]+\n/g, '\n')
    .trim();
}

// Truncate without cutting words; prefer sentence boundary if possible
export function smartExcerpt(text, maxChars = 220) {
    if (!text) return '';
    if (text.length <= maxChars) return text;

// Try to cut at sentence end within range
    const slice = text.slice(0, maxChars + 40);
    const sentenceEnd = slice.search(/([.!?])\s+[A-Z*]/g);
    if (sentenceEnd > 40 && sentenceEnd <= maxChars) {
        return slice.slice(0, sentenceEnd + 1) + ' …';
    }

// Fallback: cut at last space before limit
    const lastSpace = text.lastIndexOf(' ', maxChars);
    return text.slice(0, lastSpace > 0 ? lastSpace : maxChars).trimEnd() + ' …';
}

export function formatDate(text) {
  const date = parseISO(text);
  return format(date, 'MMMM d, yyyy');
}
/*
export function formatDate(input, opts) {
  if (!input) return "";                         // guard

  // Accept Date or string; make "YYYY-MM-DD HH:mm:ss" Safari-safe
  const s = input instanceof Date ? input : String(input).trim().replace(" ", "T");
  const d = input instanceof Date ? input : new Date(s);

  if (Number.isNaN(d.getTime())) return "";      // invalid -> blank

  const options = { year: "numeric", month: "short", day: "numeric", ...(opts || {}) };
  try { return d.toLocaleDateString(undefined, options); }
  catch { return ""; }
}
  */